import React from 'react';

import { cn } from '@app/shared/utils/common';

export function SlideContainer({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex flex-1 flex-col', className)} {...rest} />;
}
